import React from "react";

import MagicForm from "../../../components/smart/supported/MagicForm";
import mapStateToProps from "../../../components/smart/delegator/mapStateToProps";

import { connect } from "react-redux";
import withLoaderData from "../../../components/withLoaderData";
import axiosBackend from "../../../core/api/backend";

class AddRole extends React.Component {
    constructor(props) {
        super(props);

        this.addRole = this.addRole.bind(this);
    }

    addRole({ tuple }, callback) {
        axiosBackend({
            method: "PUT",
            url: `/service/sites-that-users-control/roles/${this.props.router.params.appUUID}/`,
            data: tuple,
        })
            .then((response) => {
                this.props.onComplete && this.props.onComplete(response.data.results[0]);
                
                this.props.dispatch({
                    type: "ResolvedData",
                    name: "ModalData",
                    data: {
                        show: true,
                        type: "success",
                        title: "Success",
                        message: [
                            "The new role was added to your application successfully.",
                            "You can now assign users to the role."
                        ],
                        okayButtonText: "Okay",
                    },
                });
            })
            .catch((err) => {
                console.error(err);

                this.props.dispatch({
                    type: "ResolvedData",
                    name: "ModalData",
                    data: {
                        show: true,
                        type: "error",
                        title: "Could not add role",
                        message: err?.response?.data?.messages || [
                            "Due to an error, we were unable to add the new role to your application.",
                            "Please try again in a little while."
                        ],
                        okayButtonText: "Okay"
                    },
                });
            })
            .finally(callback);
    }

    render() {
        return (
            <div className="col-sm-12">
                <h2>Add New Role</h2>
                <MagicForm
                    onSubmit={this.addRole}
                    fields={[
                        {
                            "name": {
                                "label": "Name of the role",
                                "type": "text",
                                "placeholder": "Enter the name of the role",
                                "classes": [],
                            }
                        }
                    ]}
                />
            </div>
        );
    }
}

export default withLoaderData(connect(mapStateToProps)(AddRole));
